import React from 'react';
import './src/styles/global.css';
import { ResponsiveProvider } from './src/contexts/ResponsiveContext';
import { ThemeProvider } from './src/contexts/ThemeContext';

export const wrapRootElement = ({ element }) => {
  return (
    <ResponsiveProvider>
      <ThemeProvider>{element}</ThemeProvider>
    </ResponsiveProvider>
  );
};
